import baseApi from "./baseApi";

export const getPresentationFile = async (data) => {
  const response = await baseApi.post(
    "/presentation/generate-presentation",
    {
      data,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response;
};
